/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
import { conversationsAppendConversationMessage } from "../funcs/conversationsAppendConversationMessage.js";
import { conversationsCreateConversation } from "../funcs/conversationsCreateConversation.js";
import { conversationsListConversationMessages } from "../funcs/conversationsListConversationMessages.js";
import { ClientSDK } from "../lib/sdks.js";
import { unwrapAsync } from "../types/fp.js";
export class Conversations extends ClientSDK {
    /**
     * Create a new conversation.
     */
    async createConversation(request, options) {
        return unwrapAsync(conversationsCreateConversation(this, request, options));
    }
    /**
     * List all messages in a conversation.
     */
    async listConversationMessages(request, options) {
        return unwrapAsync(conversationsListConversationMessages(this, request, options));
    }
    /**
     * Append a message to a conversation and generate a new response.
     */
    async appendConversationMessage(request, options) {
        return unwrapAsync(conversationsAppendConversationMessage(this, request, options));
    }
}
//# sourceMappingURL=conversations.js.map